module.exports = __webpack_public_path__ + "static/img/aqyd.da58859.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newHome/aqyd.png
// module id = MKtu
// module chunks = 1